import PropTypes from "prop-types";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Page from "../components/layout/Page";
import useAccount from "../hooks/useAccount";
import { updatePassword } from "../redux/accounts";

const AccountUpdatePassword = (_props, context) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const newHeaders = {
    "access-token": searchParams.get("access-token"),
    client: searchParams.get("client"),
    uid: searchParams.get("uid"),
  };

  const { currentUser, updatePasswordErrors } = useAccount();

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    dispatch(
      updatePassword({
        ...data,
        newHeaders,
        successCallbackFnc: () => {
          reset();
          navigate("/dashboard");
        },
      })
    );
  };

  return (
    <Page title={context.t("Account New Password")}>
      <Container>
        <Row>
          <Col md={{ size: 6, offset: 3 }}>
            <h1>{context.t("Set a New Password")}</h1>
            {currentUser ? (
              <p>{context.t("Already logged in")}</p>
            ) : (
              <Form onSubmit={handleSubmit(onSubmit)}>
                <FormGroup>
                  <Label for="password">{context.t("Password")}</Label>
                  <Controller
                    render={({ field }) => (
                      <Input
                        {...field}
                        onChange={(v) => {
                          field.onChange(v);
                        }}
                        type="password"
                        id="password"
                        invalid={
                          errors?.password || updatePasswordErrors?.password
                        }
                        autoComplete="new-password"
                      />
                    )}
                    name="password"
                    control={control}
                    rules={{ required: true, minLength: 6 }}
                    defaultValue=""
                  />

                  {errors.password?.type === "required" && (
                    <p className="text-danger small mt-1">
                      {context.t("Password")} {context.t("is required")}
                    </p>
                  )}

                  {errors.password?.type === "minLength" && (
                    <p className="text-danger small mt-1">
                      {context.t("Password")} {context.t("is too short")}
                    </p>
                  )}

                  {updatePasswordErrors?.password?.map((error) => (
                    <p className="text-danger small mt-1" key={error}>
                      {error}
                    </p>
                  ))}
                </FormGroup>

                <FormGroup>
                  <Label for="password_confirmation">
                    {context.t("Password Confirmation")}
                  </Label>
                  <Controller
                    render={({ field }) => (
                      <Input
                        {...field}
                        onChange={(v) => {
                          field.onChange(v);
                        }}
                        type="password"
                        id="password_confirmation"
                        invalid={
                          errors?.password_confirmation ||
                          updatePasswordErrors?.password_confirmation
                        }
                        autoComplete="new-password"
                      />
                    )}
                    name="password_confirmation"
                    control={control}
                    rules={{
                      required: true,
                      minLength: 6,
                      validate: {
                        match: (v) => v === getValues("password"),
                      },
                    }}
                    defaultValue=""
                  />

                  {errors.password_confirmation?.type === "required" && (
                    <p className="text-danger small mt-1">
                      {context.t("Password")} {context.t("Confirmation")}{" "}
                      {context.t("is required")}
                    </p>
                  )}
                  {errors.password_confirmation?.type === "minLength" && (
                    <p className="text-danger small mt-1">
                      {context.t("Password")} {context.t("Confirmation")}{" "}
                      {context.t("is too short")}
                    </p>
                  )}
                  {errors.password_confirmation?.type === "match" && (
                    <p className="text-danger small mt-1">
                      {context.t("Passwords")} {context.t("do not match")}
                    </p>
                  )}

                  {updatePasswordErrors?.password_confirmation?.map((error) => (
                    <p className="text-danger small mt-1" key={error}>
                      {error}
                    </p>
                  ))}
                </FormGroup>

                <Button type="submit" color="primary" className="w-100 mb-3">
                  {context.t("Submit")}
                </Button>
              </Form>
            )}
          </Col>
        </Row>
      </Container>
    </Page>
  );
};

AccountUpdatePassword.contextTypes = {
  t: PropTypes.func,
};

export default AccountUpdatePassword;
